import { Skeleton } from "antd";
import SectionCardSkeleton from "./SectionCardSkeleton";

const StartBannerSkeleton = () => (
    <SectionCardSkeleton className="shadow-sm">
        <div className="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
            <div className="flex min-w-0 flex-1 items-start gap-4">
                <Skeleton.Node active className="!h-11 !w-11 !rounded-xl" />
                <div className="min-w-0 flex-1">
                    <Skeleton active title={{ width: "70%" }} paragraph={{ rows: 2, width: ["100%", "85%"] }} />
                </div>
            </div>
            <Skeleton.Button active block className="!h-11 !max-w-[170px] !rounded-full lg:!w-[170px]" />
        </div>
    </SectionCardSkeleton>
);

export default StartBannerSkeleton;
